import React, {useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {useIntl} from 'react-intl';
import {useFormik} from 'formik';
import {LANGUAGES} from "../../../mock/languages";
import {useNotification} from "../../../context/NotificationContext";
import {getFaqById, updateFaq} from "../../../services/faqSvc";
import {useQuery} from "react-query";
import {LoaderSection} from "../../../components/sections/loader/Loader";
import {EmptySection} from "../../../components/sections/empty/Empty";
import {lang} from "../../../types/lang";

export const FaqUpdatePage = () => {
  const navigate = useNavigate();
  const {faqId} = useParams();
  const {formatMessage} = useIntl();
  const {showNotification} = useNotification();
  const [activeTab, setActiveTab] = useState<lang>("uz");

  const {
    data: faqById,
    isLoading: faqByIdIsLoading,
    isError: faqByIdIsError
  } = useQuery(["getFaqById"], () => getFaqById(Number(faqId)));

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      question: {
        uz: faqById?.question_uz || "",
        ru: faqById?.question_ru || "",
        en: faqById?.question_en || "",
      },
      answer: {
        uz: faqById?.answer_uz || "",
        ru: faqById?.answer_ru || "",
        en: faqById?.answer_en || "",
      },
    },
    onSubmit: async (values, {resetForm}) => {
      const formData = new FormData();
      formData.append('question_uz', values.question.uz);
      formData.append('question_ru', values.question.ru);
      formData.append('question_en', values.question.en);
      formData.append('answer_uz', values.answer.uz);
      formData.append('answer_ru', values.answer.ru);
      formData.append('answer_en', values.answer.en);

      try {
        const res = await updateFaq(Number(faqId), formData);
        if (res?.success) {
          showNotification("Muvaffaqiyatli", "Tezkor savol yangilandi", "success");
          setTimeout(() => {
            navigate(-1);
          }, 1000);
        }
      } catch (e) {
        showNotification("Xatolik!", "", "error");
      }
    },
  });

  const handleTabChange = (lang) => {
    setActiveTab(lang);
  };

  if (faqByIdIsError) return <EmptySection height={"50vh"}/>;

  return (
      <div>
        {faqByIdIsLoading ? <LoaderSection height={"50vh"}/> : (
            <div className={"card"}>
              <div className="card-header">
                <h1 className="card-title">Tezkor qo'shish</h1>
                <ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
                  {LANGUAGES.map((lang) => (
                      <li className="nav-item" key={lang.key}>
                        <button
                            className={`nav-link ${activeTab === lang.key ? 'active' : ''}`}
                            onClick={() => handleTabChange(lang.key)}
                        >
                          {lang.name}
                        </button>
                      </li>
                  ))}
                </ul>
              </div>
              <div className="card-body">
                <div id="kt_account_profile_details" className="collapse show">
                  <form
                      className="form"
                      onSubmit={formik.handleSubmit}
                      encType="multipart/form-data"
                  >
                    <div className="card-body p-9">
                      <div className="row mb-6">
                        <label className="col-lg-4 col-form-label required fw-bold fs-6">
                          Savol
                        </label>
                        <div className="col-lg-8 fv-row">
                      <textarea
                          className="form-control form-control-lg form-control-solid"
                          placeholder="Savol"
                          name={`question.${activeTab}`}
                          value={formik.values.question[activeTab]}
                          onChange={formik.handleChange}
                      />
                          {formik.touched.question?.[activeTab] && formik.errors.question?.[activeTab] && (
                              <div className="text-danger">{formik?.errors?.question?.[activeTab]?.toString()}</div>
                          )}
                        </div>
                      </div>
                      <div className="row mb-6">
                        <label className="col-lg-4 col-form-label required fw-bold fs-6">
                          Javob
                        </label>
                        <div className="col-lg-8 fv-row">
                      <textarea
                          className="form-control form-control-lg form-control-solid"
                          placeholder="Javob"
                          rows={10}
                          name={`answer.${activeTab}`}
                          value={formik.values.answer[activeTab]}
                          onChange={formik.handleChange}
                      />
                          {formik.touched.answer?.[activeTab] && formik.errors.answer?.[activeTab] && (
                              <div className="text-danger">{formik.errors.answer?.[activeTab]?.toString()}</div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="card-footer">
                      <div className="justify-content-end d-flex gap-2">
                        <button
                            className="btn btn-secondary"
                            onClick={() => navigate(-1)}
                            type="button"
                        >
                          {formatMessage({id: "Bekor qilish"})}
                        </button>
                        <button
                            disabled={formik.isSubmitting}
                            className="btn btn-primary"
                            type="submit"
                        >
                          {formik.isSubmitting ? "Saqlanmoqda..." : "Saqlash"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
        )}
      </div>
  );
};